// @owners { team: patients }
import { useQuery } from '@tanstack/react-query';
import { staleTimes } from '~shared/queries/constants';
import { queries } from '~shared/queries/query-keys';

export const useQueryInsurancePageContent = ({ hubReferralID }: { hubReferralID: number }) => {
  const { isFetching, isSuccess, data, isError } = useQuery({
    ...queries.hubReferralInfoRequestConfigs.fetchInsurancePageContent({
      params: {
        hub_referral_id: hubReferralID,
      },
    }),
    enabled: !!hubReferralID,
    staleTime: staleTimes.fiveMinutes,
  });

  return {
    isFetching,
    isSuccess,
    isError,
    programName: data?.data?.program_name,
    headerLogoUrl: data?.data?.header_logo_url,
    nextURL: data?.data?.next_url,
    redirectURL: data?.data?.redirect_url,
  };
};
